import { ZendeskFormFields } from './ZendeskTypes'

export const mapToRole = (session) => {
  if (session.isDealer) return 'dd_dealer_role'
  if (session.isFsr) return 'dd_fsr_role'
  if (session.isTechnician) return 'dd_technician'
  if (session.isAdmin) return 'dd_admin'
  return null
}

export const getBrandValue = (Brand) => {
  return {
    commercial: 'pivot',
    asAirHome: 'american_standard',
    default: 'trane'
  }[
    Brand.isCommercial() ? 'commercial'
      : Brand.isASAirHome() ? 'asAirHome'
        : 'default'
  ]
}
export const getDealerTier = (tier?: string) => {
  switch (tier) {
    case 'standard':
      return 'dd_standard'
    case 'premium':
      return 'dd_premium'
    default:
      return 'dd_elite'
  }
}

export const dealerTierMap: Record<string, string> = {
  standard: 'dd_standard',
  premium: 'dd_premium',
  elite: 'dd_elite'
}

export const subscriptionTypeMap: Record<string, string> = {
  diag_yearly: 'dd_annual',
  diag_monthly: 'dd_monthly',
  diag_monthly_trial: 'dd_monthly_trial',
  diag_yearly_trial: 'dd_annual_trial'
}

export const validateFields = (fields: ZendeskFormFields) => {
  const errors: Record<string, string> = {}

  if (!fields.name.trim()) {
    errors.name = 'Enter a valid name'
  }

  if (!fields.email.trim() || (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email))) {
    errors.email = 'Enter a valid email address'
  }

  if (!fields.subject.trim()) {
    errors.subject = 'Enter a value for subject'
  }

  return errors
}
